import { Box, Button, Grid, Typography, MenuItem, TextField, Divider, Modal, Accordion, AccordionSummary, AccordionDetails, FormControlLabel, Checkbox, Autocomplete, LinearProgress, useMediaQuery, useTheme, Breadcrumbs, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { HttpRequest } from "../HttpRequest";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Add, AddCircleOutline, ArrowBackIos, HelpOutline } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomInputLabel from "../common/CustomInputLabel";
import { useDispatch, useSelector } from "react-redux";
import { setProductTypeData, setProductCategory, setProductName, setProductDescription, setProductIsPackage, setMaxNoOfItems, setVariations, setFeaturedImage, setThumbnailImage, setAdditionalImages, setPricingData, setTagsData, setAdditionalServicesData } from "../../features/productSlice";
import CloseIcon from "@mui/icons-material/Close";
import PricingComponent from "./PricingComponent";
import imagePlaceholder from "../../images/img-holder-icn.svg";
import { SuccessAlert } from "../common/snackbar/success";
import { ErrorAlert } from "../common/snackbar/error";
import generateImageUrl from "../common/generateImageUrl";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormGroup from '@mui/material/FormGroup';

import secureLocalStorage from "react-secure-storage";
import EditPricingComponent from "./EditPricingComponent";
import CustomSelect from "../common/customSelectInput";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const AddProductsmodal = {
  borderRadius: "10px",
  backgroundColor: "#fff",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90vw", sm: "500px", md: "600px" },
  height: { xs: "auto", sm: "390px" },
  p: 2,
  maxHeight: "90vh",
  overflow: "auto"
};
const AddServicesmodal = {
  borderRadius: "10px",
  backgroundColor: "#fff",
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "600px",
  height: "auto",
  p: 2,
  overflow: 'scroll'
};
const EditProduct = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const { productTypeData, productName, pricingData, productCategory, productDescription, productIsPackage, maxNoOfItems, featuredImage, thumbnail, additionalImages, variations, tagsData, additionalServicesData
  } = useSelector((state) => state.product);
  const dispatch = useDispatch();

  const [productTypeOptions, setProductTypeOptions] = useState([
    {
      id: 1,
      label: "Simple Product",
      value: "simple_product",
      description: "Product variations shares same stock and pricing",
    },
    {
      id: 2,
      label: "Variable Product",
      value: "variable_product",
      description: "Each product variations has its own stock and pricing",
    },
  ]);
  const { additionalServicesEnabled, ecommerceUrlEnabled } = useSelector((store) => store.configs);
  const [categories, setCategories] = useState([]);
  const additionalImagesItems = [0, 1, 2, 3];
  const [productType, setProductType] = useState(productTypeData ? productTypeData : "simple_product");
  const [tags, setTags] = useState([]);
  const [additionalServices, setAdditionalServices] = useState([]);
  const navigate = useNavigate();
  const [servicesEnabled, setServicesEnabled] = useState(additionalServicesEnabled);
  const [product, setProduct] = useState({});
  const { productId } = useParams();
  const [categorySearch, setCategorySearch] = useState('');
  const [allBusinessVariations, setAllBusinessVariations] = useState([])
  const [limit, setLimit] = useState(10);
  const handleproductTypeOptionsChange = (value) => {
    setProductType(value);
  };
  const [openVariantAdd, setOpenVariantAdd] = useState(false);
  const handleOPenVariantAdd = () => {
    setOpenVariantAdd(true);
  };
  const handleCloseVariantAdd = () => {
    setOpenVariantAdd(false);
  };
  const [openTagsAdd, setOpenTagsAdd] = useState(false);
  const handleOPenTagsAdd = () => {
    setOpenTagsAdd(true);
  };
  const handleCloseTagsAdd = () => {
    setOpenTagsAdd(false);
  };
  const [openServicesAdd, setOpenServicesAdd] = useState(false);
  const handleOPenServicesAdd = () => {
    setOpenServicesAdd(true);
  };
  const handleCloseServicesAdd = () => {
    setOpenServicesAdd(false);
  };
  const [uploading, setUploading] = useState('');
  const [displayBars, setDisplayBars] = useState("productDetails");
  const [isLoading, setIsLoading] = useState(true);

  const activeClassBar = {
    height: { xs: "40px", sm: "45px" },
    backgroundColor: "#fafafa",
    width: "100%",
    color: "#0000",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  };
  const inactiveClassBar = {
    height: { xs: "40px", sm: "45px" },
    backgroundColor: "#fff",
    width: "100%",
    color: "#707070",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  };

  const activeClassText = {
    color: "#000",
    fontSize: { xs: "14px", sm: "16px" },
    fontStyle: "normal",
    fontWeight: "600",
    paddingTop: { xs: "0", sm: "10px" },
    paddingLeft: { xs: "8px", sm: "0" },
  };
  const inactiveClassText = {
    color: "#707070",
    fontSize: { xs: "14px", sm: "16px" },
    fontStyle: "normal",
    fontWeight: "600",
    paddingTop: { xs: "0", sm: "10px" },
    paddingLeft: { xs: "8px", sm: "0" },
  };

  const handleChangeBars = (value) => {
    setDisplayBars(value);
  };
  const [successShow, setSuccessShow] = useState({ state: false, message: "" })
  const [errorShow, setErrorShow] = useState({ state: false, message: "" })

  const [variationName, setVariationName] = useState("");
  const [variationValues, setVariationValues] = useState(" ");
  const [variationNameError, setVariationNameError] = useState(false);
  const [variationNameHelperText, setVariationHelperText] = useState('');

  const [variationData, setVariationData] = useState(variations);
  const [productFeaturedImage, setProductFeaturedImage] = useState("");
  const [additionalProductImages, setAdditionalProductImages] = useState([]);
  const [selectedTags, setSelectedTags] = useState(tagsData);
  const [selectedAdditionalServices, setSelectedAdditionalServices] = useState(Array.isArray(additionalServicesData) ? additionalServicesData : []);
  const [variationId, setVariationId] = useState('');
  const [checkedVariations, setCheckedVariations] = useState({});
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const handleChange = (event) => {
    const { name, checked, value } = event.target;
    if (checked) {
      const newTag = { tagId: value, tagName: name };
      const newSelectedTags = [...selectedTags, newTag];
      setSelectedTags(newSelectedTags);
      setFormData((prevFormData) => ({ ...prevFormData, tags: newSelectedTags }));
      dispatch(setTagsData(newSelectedTags));
    } else {
      const newSelectedTags = selectedTags.filter((tag) => tag.tagId !== value);
      setSelectedTags(newSelectedTags);
      setFormData((prevFormData) => ({ ...prevFormData, tags: newSelectedTags }));
      dispatch(setTagsData(newSelectedTags));
    }
  };
  const handleChangeAdditionalServices = (event) => {
    const { name, checked, value } = event.target;
    if (checked) {
      const newService = { serviceId: value, serviceName: name };
      const newSelectedServices = [...selectedAdditionalServices, newService];
      setSelectedAdditionalServices(newSelectedServices);
      setFormData((prevFormData) => ({ ...prevFormData, additionalServices: newSelectedServices }));
      dispatch(setAdditionalServicesData(newSelectedServices));
    } else {
      const newSelectedServices = selectedAdditionalServices?.filter((service) => service.serviceId !== value);
      setSelectedAdditionalServices(newSelectedServices);
      setFormData((prevFormData) => ({ ...prevFormData, additionalServices: newSelectedServices }));
      dispatch(setAdditionalServicesData(newSelectedServices));
    }
  };

  const handleChangeVariationName = (e) => {
    const { value } = e.target;
    if (value.trim() !== '' && value.includes(' ')) {
      setErrorShow({ state: true, message: 'Variant name cannot contain spaces!' });
      setVariationHelperText('Variant name cannot contain spaces!');
      setVariationNameError(true);
    } else {
      setVariationName(value);
    }
  };
  const handleAddBox = () => {
    setServiceBoxes([...serviceBoxes, { serviceName: '', cost: '', customizable: false }]);
  };
  const handleDeleteBox = (indexToRemove) => {
    setServiceBoxes(serviceBoxes.filter((_, index) => index !== indexToRemove));
  };
  const handleServicesFormData = (e) => {
    setServiceData({ ...serviceData, [e.target.name]: e.target.value });
  };
  const handleTagsFormData = (e) => {
    const { name, value } = e.target;
    setTagDataData({ ...tagDataData, [name]: value });
  };
  const handleServiceSubmit = () => {
    const isAnyEmpty = serviceBoxes.some(box => box.serviceName === '' || box.cost === '');
    if (isAnyEmpty) {
      setErrorShow({ state: true, message: "Please fill all fields" });
      return;
    }
    if (serviceData.serviceName === '' || serviceData.selectionType === '') {
      setErrorShow({ state: true, message: "Please fill all fields" });
      return;
    }

    const items = serviceBoxes.map(box => ({ itemName: box.serviceName, itemPrice: box.cost, isCustomizable: box?.customizable }));
    const data = { ...serviceData, items };

    HttpRequest({
      method: 'POST',
      url: `/api/v1/ecommerce/add_additional_services`,
      body: data,

    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Additional Service added successfully" });
        handleCloseServicesAdd();
        setServiceData({
          serviceName: '',
          selectionType: '',
          items: []
        });
        setServiceBoxes([{ serviceName: '', cost: '' }]);
        fetchAdditionalServices();
      } else {
        setErrorShow({ state: true, message: data.response?.data?.message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: "Error adding service" });
    })
  };
  const handleTagAddSubmit = () => {
    if (!tagDataData.tagName) {
      setErrorShow({ state: true, message: "Tag name is required" });
      return;
    }
    if (!tagDataData.tagDescription) {
      setErrorShow({ state: true, message: "Tag description is required" });
      return;
    }
    HttpRequest({
      method: 'POST',
      url: `/api/v1/ecommerce/business/addTag`,
      body: tagDataData

    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Tag Name added successfully" });
        fetchBusinessTags();
        handleCloseTagsAdd();
        setTagDataData({
          tagName: "",
          tagDescription: "",

        })
      } else {
        setErrorShow({ state: true, message: data.response?.data?.message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: "Error adding shipping Region" });
    })
  }
  const handleVariations = () => {
    const checkVariationName = variationData.findIndex(
      (item) => item && item.variationName === variationName
    );
    let updatedVariationData;

    if (checkVariationName === -1) {
      // New variation type being added
      updatedVariationData = [
        ...variationData,
        {
          variationName: variationName.trim(),
          variationValues: variationValues.split(",").map(v => v.trim()).filter(v => v !== ''),
        },
      ];
    } else {
      // Adding values to existing variation
      updatedVariationData = variationData.map((item) => {
        if (item.variationName === variationName) {
          const newValues = variationValues.split(",").map(v => v.trim()).filter(v => v !== '');
          const existingValues = item.variationValues || [];
          const uniqueNewValues = newValues.filter(v => !existingValues.includes(v));

          if (uniqueNewValues.length > 0) {
            return { ...item, variationValues: [...existingValues, ...uniqueNewValues] };
          }
        }
        return item;
      });
    }

    // ALWAYS regenerate ALL pricing combinations from scratch (like AddProduct.js does)
    // This ensures consistency and prevents duplicate/missing combinations
    if (updatedVariationData.length > 0) {
      const allCombinations = generateAllFreshCombinations(updatedVariationData);

      // Clear all old pricing and set the new combinations
      setFormData(prevFormData => ({
        ...prevFormData,
        variations: updatedVariationData,
        pricing: [],  // Clear existing pricing
        newPricing: allCombinations  // Set all new combinations
      }));

      setSuccessShow({
        state: true,
        message: `Variations updated. ${allCombinations.length} pricing combinations generated. Please review and update them in the Pricing & Stock section.`
      });
    } else {
      setFormData(prevFormData => ({
        ...prevFormData,
        variations: updatedVariationData,
        pricing: [],
        newPricing: []
      }));
    }

    setVariationData(updatedVariationData);
    dispatch(setVariations(updatedVariationData));
    secureLocalStorage.setItem("variationData", JSON.stringify(updatedVariationData));

    setVariationName("");
    setVariationValues("");
    handleCloseVariantAdd();
  };

  const [formData, setFormData] = useState({
    productType: productTypeData ? productTypeData : " ",
    productName: productName ? productName : " ",
    productCategory: productCategory ? productCategory : " ",
    productDescription: productDescription ? productDescription : " ",
    isPackage: productIsPackage ? productIsPackage : false,
    noOfItemsInPackage: maxNoOfItems ? maxNoOfItems : 0,
    featuredImage: featuredImage ? featuredImage : " ",
    thumbailImagePath: thumbnail ? thumbnail : '',
    additionalImages: additionalImages ? additionalImages : [],
    variations: variations ? variations:  [],
    productCategoryId: "",
    pricing: [],
    newPricing:[],
    tags: tagsData ? tagsData : [],
    additionalServices: additionalServicesData ? additionalServicesData : []
  });

  const handleFormData = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.name === 'productCategory') {
      const filteredCategory = categories.find(item => item.categoryName === e.target.value);
      setFormData({ ...formData, productCategoryId: filteredCategory?._id, productCategory: e.target.value })
    }
  };
  const findCategoryByName = (categories, categoryName) => {
    for (const category of categories) {
      if (category.categoryName === categoryName) {
        return category;
      }

      if (category.subCategories && category.subCategories.length > 0) {
        const foundInChildren = findCategoryByName(category.subCategories, categoryName);
        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }

    return null;
  };

   const receivingPricingData = (data) => {
    console.log(data , 'received props update ##')
    setFormData({ ...formData, pricing: data , newPricing:data });
  };

  console.log(checkedVariations, 'checkedVariations @@')

  const handleCheckboxChange = (index) => {
    const variationName = allBusinessVariations?.[index]?.variationName;
    const variation = allBusinessVariations?.[index];

    if (variationName) {
      const isCurrentlyChecked = checkedVariations[variationName];

      // Toggle the checkbox state
      setCheckedVariations((prev) => ({
        ...prev,
        [variationName]: !isCurrentlyChecked
      }));

      // If unchecking, remove all pricing entries related to this variation
      if (isCurrentlyChecked) {
        setFormData((prevFormData) => {
          // Remove pricing entries that contain any values from this variation
          const updatedPricing = (prevFormData.pricing || []).filter((priceEntry) => {
            if (!priceEntry.variationKey) return true;

            const pricingValues = priceEntry.variationKey.split(",").map(v => v.trim().toUpperCase());
            const variationValues = variation.variationValues?.map(v => v.trim().toUpperCase()) || [];

            // Keep the pricing entry only if it doesn't contain any of this variation's values
            return !pricingValues.some(pVal => variationValues.includes(pVal));
          });

          // Also remove from newPricing
          const updatedNewPricing = (prevFormData.newPricing || []).filter((priceEntry) => {
            if (!priceEntry.variationKey) return true;

            const pricingValues = priceEntry.variationKey.split(",").map(v => v.trim().toUpperCase());
            const variationValues = variation.variationValues?.map(v => v.trim().toUpperCase()) || [];

            return !pricingValues.some(pVal => variationValues.includes(pVal));
          });

          // Remove this variation from formData.variations
          const updatedVariations = (prevFormData.variations || []).filter(
            v => v.variationName !== variationName
          );

          return {
            ...prevFormData,
            pricing: updatedPricing,
            newPricing: updatedNewPricing,
            variations: updatedVariations
          };
        });

        // Also remove from newSelectedVariationValues
        setNewSelectedVariationValues((prevValues) =>
          prevValues.filter(v => v.variationName !== variationName)
        );

        setSuccessShow({
          state: true,
          message: `Variation "${variationName}" has been removed. All related pricing entries have been deleted.`
        });
      }
    }
  };

  useEffect(() => {
    // Initialize checked variations ONLY on initial load
    // Do NOT recalculate when pricing changes (to prevent unchecking all variations)
    if (isInitialLoad && formData?.variations?.length > 0 && allBusinessVariations?.length > 0 && formData?.pricing?.length > 0) {
      // Check which variations actually have pricing entries
      const variationNamesInPricing = new Set();
      const pricingToCheck = formData?.pricing || [];

      if (pricingToCheck.length > 0) {
        // For each business variation, check if any pricing entry contains its values
        allBusinessVariations.forEach(businessVar => {
          const hasValueInPricing = pricingToCheck.some(priceEntry => {
            if (!priceEntry.variationKey) return false;

            const pricingValues = priceEntry.variationKey.split(",").map(v => v.trim().toUpperCase());
            const businessVarValues = businessVar.variationValues?.map(v => v.trim().toUpperCase()) || [];

            // Check if any pricing value matches any business var value
            return pricingValues.some(pVal => businessVarValues.includes(pVal));
          });

          if (hasValueInPricing) {
            variationNamesInPricing.add(businessVar.variationName);
          }
        });
      }

      // Only check variations that have actual pricing entries
      const initialChecked = {};
      allBusinessVariations?.forEach((item) => {
        initialChecked[item?.variationName] = variationNamesInPricing.has(item?.variationName);
      });
      setCheckedVariations(initialChecked);
      setIsInitialLoad(false); // Mark initial load as complete
    }
  }, [allBusinessVariations, formData.variations, formData.pricing, isInitialLoad]);


    const handleChildCheckboxToggle = (item, value, checked, parentIndex) => {
      setFormData((prevFormData) => {
        let updatedPricing = [...(prevFormData.pricing || [])];
        let updatedVariations = [...(prevFormData.variations || [])];

        if (checked) {
          const newPricingEntry = {
            variationKey: `${item.variationKey ? item.variationKey + "," : ""}${value.trim()}`,
          };
          updatedPricing.push(newPricingEntry);
        } else {
          // Remove pricing entries containing this value
          updatedPricing = updatedPricing.filter(
            (p) =>
              !p.variationKey
                ?.split(",")
                ?.map((f) => f.trim())
                .includes(value.trim())
          );

          // Also remove the value from formData.variations
          updatedVariations = updatedVariations.map(variation => {
            if (variation.variationName === item.variationName) {
              return {
                ...variation,
                variationValues: variation.variationValues.filter(v => v.trim() !== value.trim())
              };
            }
            return variation;
          }).filter(variation => variation.variationValues.length > 0);
        }

        return {
          ...prevFormData,
          pricing: updatedPricing,
          variations: updatedVariations
        };
      });
  };

  const [newSelectedVariationValues, setNewSelectedVariationValues] = useState([]);
  const [tagDataData, setTagDataData] = useState({
    tagName: "",
    tagDescription: "",
  });
  const [serviceBoxes, setServiceBoxes] = useState([{ serviceName: '', cost: '' }]);
  const [serviceData, setServiceData] = useState({
    serviceName: '',
    selectionType: '',
    items: []
  });
  const selectOptions = [
    { id: 1, label: 'Multiple', value: 'multiple' },
    { id: 2, label: 'Single', value: 'single' },
  ];

 const handleNewChildCheckboxToggle = (item, value, checked) => {
      setNewSelectedVariationValues((prevValues) => {
        let updatedValues = [...prevValues];
        let variationIndex = updatedValues.findIndex((v) => v.variationName === item?.variationName);
        if (checked) {
          if (variationIndex === -1) {
              updatedValues.push({
                variationName: item?.variationName,
                variationValues: [value.trim()],
              });
          } else {
            if (!updatedValues[variationIndex].variationValues.includes(value.trim())) {
              updatedValues[variationIndex].variationValues.push(value.trim());
            }
          }
        } else {
          if (variationIndex !== -1) {
            updatedValues[variationIndex].variationValues = updatedValues[
              variationIndex
            ].variationValues.filter((v) => v !== value.trim());

            if (updatedValues[variationIndex].variationValues.length === 0) {
              updatedValues = updatedValues.filter(
                (v) => v.variationName !== item.variationName
              );
            }
          }

          // When unchecking, also remove pricing entries containing this value
          setFormData(prevFormData => {
            const updatedNewPricing = (prevFormData.newPricing || []).filter((priceEntry) => {
              if (!priceEntry.variationKey) return true;

              const pricingValues = priceEntry.variationKey.split(",").map(v => v.trim().toUpperCase());
              return !pricingValues.includes(value.trim().toUpperCase());
            });

            return {
              ...prevFormData,
              newPricing: updatedNewPricing
            };
          });
        }

        // Regenerate pricing combinations after updating variations (only when checking)
        if (checked) {
          const allVariations = mergeVariations(formData.variations || [], updatedValues);
          const newCombinations = generateAllFreshCombinations(allVariations);

          // Update formData with new pricing combinations
          setFormData(prevFormData => ({
            ...prevFormData,
            newPricing: newCombinations
          }));
        }

        return updatedValues;
  });
};

  const [pricingObj, setpricingObj] = useState({
    pricing: {
      initialStock: "",
      runningLowLevel: "",
      normalPrice: "",
      discountedPrice: "",
      buyingPrice: ""
    }
  })

  // const handlePrincingNewObject = () => {
  //   let newPricing = pricingObj.pricing
  //   newPricing = { ...newPricing, variationKey: "default" }

  //   formData.pricing = [{ ...newPricing }]

  //   setFormData({ ...formData, pricing: [newPricing] })
  //   let newPricingData = [newPricing]
  //   dispatch(setPricingData(newPricingData))
  // }
  const handleVariationChange = () => {
    const defaultvariations = [{
      "variationName": "default",
      "variationValues": [
        "default"
      ]
    }]
    setFormData({ ...formData, variations: defaultvariations })
  }

  useEffect(() => {
    // handlePrincingNewObject()
    if (productType === "simple_product") {
      handleVariationChange()
    }
  }, [productType])

  const [buttonState, setButtonState] = useState(false);

  const nextButtonState = () => {
    if (displayBars === "productDetails") {
      if (
        formData.productName !== "" &&
        formData.productCategory !== "" &&
        formData.productDescription !== ""
      ) {
        setButtonState(false);
      } else {
        setButtonState(true);
      }
    } else if (displayBars === "productVariations") {
      if (formData.variations.length === 0) {
        setButtonState(true);
      } else {
        setButtonState(false);
      }
    } else if (displayBars === "productPricing") {
      if (productType === "simple_product") {
        if (
          formData.pricing.initialStock !== "" &&
          formData.pricing.runningLowLevel !== "" &&
          formData.pricing.normalPrice !== "" &&
          formData.pricing.discountedPrice !== ""
        ) {
          setButtonState(false);
        } else {
          setButtonState(true);
        }
      } else if (productType === "variable_product") {
        // Check Redux pricing data first (this is where EditPricingComponent saves data)
        const pricingToCheck = pricingData && pricingData.length > 0
          ? pricingData
          : formData.pricing || [];

        if (pricingToCheck.length > 0) {
          // All pricing entries must have all required fields filled
          // Check if fields are empty string, null, or undefined (not just falsy, as 0 is valid)
          const hasEmptyFields = pricingToCheck?.some(item => {
            return item.initialStock === '' || item.initialStock === null || item.initialStock === undefined ||
                   item.normalPrice === '' || item.normalPrice === null || item.normalPrice === undefined ||
                   item.runningLowLevel === '' || item.runningLowLevel === null || item.runningLowLevel === undefined ||
                   item.discountedPrice === '' || item.discountedPrice === null || item.discountedPrice === undefined;
          });

          if(hasEmptyFields){
            setButtonState(true);   // Disable if there are empty fields
          } else {
            setButtonState(false);  // Enable if all fields are filled
          }
        } else {
          setButtonState(true);     // Disable if no pricing
        }
      }
    }
  };
  // Generate all combinations of variation values (Cartesian product)
  const generateVariationCombinations = (variations, index = 0, currentCombination = {}) => {
    if (index === variations.length) {
      return [currentCombination];
    }
    const currentVariation = variations[index];
    return currentVariation.variationValues.flatMap(value => {
      const updatedCombination = {
        ...currentCombination,
        [currentVariation.variationName]: value
      };
      return generateVariationCombinations(variations, index + 1, updatedCombination);
    });
  };

  // Extract existing variation values from current pricing
  const extractExistingVariationValues = () => {
    const existingVariationMap = {};

    if (formData.pricing && formData.pricing.length > 0) {
      formData.pricing.forEach(priceEntry => {
        if (priceEntry.variationKey) {
          // Split variationKey to get individual values
          const values = priceEntry.variationKey.split(",").map(v => v.trim());

          // Map each value to its variation type based on formData.variations
          if (formData.variations && formData.variations.length > 0) {
            formData.variations.forEach((variation, index) => {
              if (values[index]) {
                if (!existingVariationMap[variation.variationName]) {
                  existingVariationMap[variation.variationName] = [];
                }
                if (!existingVariationMap[variation.variationName].includes(values[index])) {
                  existingVariationMap[variation.variationName].push(values[index]);
                }
              }
            });
          }
        }
      });
    }

    return existingVariationMap;
  };

  // Determine if we're adding a completely new variation type or just new values
  const isNewVariationType = (variationName) => {
    return !variationData.some(v => v.variationName === variationName);
  };

  // Merge variations from formData and newly selected variations without duplicates
  const mergeVariations = (existingVariations, newVariations) => {
    const merged = [...existingVariations];

    newVariations.forEach(newVar => {
      const existingIndex = merged.findIndex(v => v.variationName === newVar.variationName);

      if (existingIndex === -1) {
        // New variation type, add it completely
        merged.push(newVar);
      } else {
        // Existing variation type, merge values
        const existingValues = new Set(merged[existingIndex].variationValues);
        newVar.variationValues.forEach(value => existingValues.add(value));
        merged[existingIndex] = {
          ...merged[existingIndex],
          variationValues: Array.from(existingValues)
        };
      }
    });

    return merged;
  };

  // Simple function to generate all fresh combinations (like AddProduct.js)
  const generateAllFreshCombinations = (variations) => {
    if (!variations || variations.length === 0) {
      return [];
    }

    // For single variation, create entries for each value
    if (variations.length === 1) {
      const singleVariation = variations[0];
      return singleVariation.variationValues.map(value => ({
        variationKey: value,
        initialStock: 0,
        runningLowLevel: 0,
        normalPrice: 0,
        discountedPrice: 0,
        buyingPrice: 0,
        variantCode: ''
      }));
    }

    // For multiple variations, generate all combinations
    const combinations = generateVariationCombinations(variations);
    return combinations.map(combination => {
      // Sort variation names to ensure consistent ordering
      const sortedVariations = variations.map(v => v.variationName).sort();
      const variationKeyParts = sortedVariations.map(varName => combination[varName]);
      const variationKey = variationKeyParts.join(",");

      return {
        variationKey: variationKey,
        initialStock: 0,
        runningLowLevel: 0,
        normalPrice: 0,
        discountedPrice: 0,
        buyingPrice: 0,
        variantCode: ''
      };
    });
  };


  const renderMenuItems = (items, level = 1) => {
    const menuItems = [];
    items.forEach((item) => {
      menuItems.push(
        <MenuItem disabled={item.subCategories.length > 0 ? true : false} key={item._id} value={item.categoryName} style={{ paddingLeft: level * 20, width: '98px', height: '20px', margin: '14px 21px 15px 22px', fontFamily: 'Poppins', fontSize: '16px', textAlign: 'left', color: '#707070', fontWeight: level < 2 ? 550 : 'normal', "&:hover": { backgroundColor: '#fff' } }}>
          {item.categoryName}
        </MenuItem>
      );
      if (item.subCategories && item.subCategories.length > 0) {
        const subMenuItems = renderMenuItems(item.subCategories, level + 1);
        menuItems.push(...subMenuItems);
      }
    });
    return menuItems;
  };

  const handleNext = () => {
    if (displayBars === "productDetails") {
      setDisplayBars("productImage");
    } else if (displayBars === "productImage") {
      if (productType === 'simple_product') {
        setDisplayBars("productPricing");
      } else {
        setDisplayBars("productVariations");
      }
    } else if (displayBars === "productVariations") {
      setDisplayBars("productPricing");
    } else if (displayBars === "productPricing") {
      setDisplayBars("tags");
    } else if (displayBars === "tags") {
      if (servicesEnabled) {
        setDisplayBars("additionalServices");
      } else {
        handleSubmit();
      }
    } else if (displayBars === "additionalServices") {
      handleSubmit();
    }
  };

  const handlePrevious = () => {
    if (displayBars === "additionalServices") {
      setDisplayBars("tags");
    } else if (displayBars === "tags") {
      setDisplayBars("productPricing");
    } else if (displayBars === "productPricing") {
      if (productType === 'simple_product') {
        setDisplayBars("productImage");
      } else {
        setDisplayBars("productVariations");
      }
    } else if (displayBars === "productVariations") {
      setDisplayBars("productImage");
    } else if (displayBars === "productImage") {
      setDisplayBars("productDetails");
    }
  };
  const handleSubmit = async () => {
    try {
      // Get the latest pricing from Redux (EditPricingComponent saves it there)
      // Redux pricingData contains the updated values from the user
      const latestPricing = pricingData && pricingData.length > 0 ? pricingData : formData.pricing;

      // Merge all variations (existing + new selected)
      const allVariations = mergeVariations(formData.variations || [], newSelectedVariationValues || []);

      // Filter variations to only include values that are present in pricing entries
      // This removes unchecked variation values from the final payload
      const filteredVariations = allVariations.map(variation => {
        // Get all variation values that appear in pricing
        const usedValues = new Set();

        latestPricing.forEach(priceEntry => {
          if (priceEntry.variationKey) {
            const values = priceEntry.variationKey.split(",").map(v => v.trim().toUpperCase());
            values.forEach(val => usedValues.add(val));
          }
        });

        // Filter this variation's values to only include those used in pricing
        const filteredValues = variation.variationValues.filter(value =>
          usedValues.has(value.trim().toUpperCase())
        );

        return {
          ...variation,
          variationValues: filteredValues
        };
      }).filter(variation => variation.variationValues.length > 0); // Remove variations with no values

      // Prepare request body with all product data including variations and pricing
      const requestBody = {
        // Basic product information
        productName: formData.productName,
        productCategory: formData.productCategory,
        productCategoryId: formData.productCategoryId,
        productDescription: formData.productDescription,
        productType: productType,
        isPackage: formData.isPackage,
        noOfItemsInPackage: formData.noOfItemsInPackage,
        featuredImage: formData.featuredImage,
        thumbailImagePath: formData.thumbailImagePath,
        additionalImages: formData.additionalImages,

        // Filtered variations (only values with pricing)
        variations: filteredVariations,

        // Use ONLY the pricing from Redux (which has the correct user-entered values)
        // Do NOT send newPricing as it contains zeros
        pricing: latestPricing,

        // Don't send newVariations or newPricing separately
        // The backend should handle all variations and pricing together

        // Tags and services
        tags: formData.tags,
        additionalServices: formData.additionalServices
      };

      HttpRequest({
        method: "POST",
        url: `/api/v1/ecommerce/edit_product/${productId}`,
        body: requestBody,
      }).then((data) => {
        if (data.status === 202 || data.status === 200) {
          setSuccessShow({ state: true, message: "Product updated successfully!" });
          dispatch(setProductTypeData(''));
          dispatch(setProductCategory(''));
          dispatch(setProductName(''));
          dispatch(setProductIsPackage(false));
          dispatch(setMaxNoOfItems(0));
          dispatch(setVariations([]));
          dispatch(setTagsData([]));
          dispatch(setProductDescription());
          dispatch(setAdditionalServicesData([]));
          dispatch(setFeaturedImage(''));
          dispatch(setThumbnailImage(''));
          dispatch(setAdditionalImages([]));
          setTimeout(() => {
            navigate('/zed_ecommerce/products');
          }, 3000);
        } else {
          const message = data.response?.message || 'Failed to update product';
          setErrorShow({ state: true, message });
        }
      }).catch((error) => {
        console.error('Product update error:', error);
        setErrorShow({ state: true, message: 'Failed to update product!' });
      });
    } catch (error) {
      console.error('Error preparing product data:', error);
      setErrorShow({ state: true, message: 'Error preparing product data!' });
    }
  };
  const fetchBusinessVariations = () => {
    const businessNumber = secureLocalStorage.getItem("businessId");
    HttpRequest({
      method: "GET",
      url: `/api/v1/ecommerce/get_business_variations?businessNumber=${businessNumber}`,
    }).then((data) => {
      if (data.status === 200) {
        const businessVariationData = data.response.data;
        let newVariationData = [];

        businessVariationData.forEach((variation) => {
          newVariationData.push({
            variationName: variation.variationName.trim(),
            variationValues: variation.variationValues,
          });
        });
        setAllBusinessVariations(businessVariationData)
        setVariationData(businessVariationData);
        setVariationData(businessVariationData);
        setFormData({ ...formData, variations: businessVariationData });
        dispatch(setVariations(businessVariationData));
      }
    }).catch((error) => {
    });
  };
  const fetchBusinessTags = () => {
    const businessNumber = secureLocalStorage.getItem("businessId");
    HttpRequest({
      method: "GET",
      url: `/api/v1/ecommerce/business/getTag?businessNumber=${businessNumber}`,
    }).then((data) => {
      if (data.status === 200) {
        setTags(data.response.data);
      }
    }).catch((error) => {
    });
  };
  const fetchAdditionalServices = () => {
    HttpRequest({
      method: "GET",
      url: `/api/v1/ecommerce/get_additional_services`,
    }).then((data) => {
      if (data.status === 200) {
        setAdditionalServices(data.response.data);
      }
    }).catch((error) => {
    });
  };
  const fetchProductDetails = () => {
    setIsLoading(true);
    const businessNumber = secureLocalStorage.getItem("businessId");
    HttpRequest({
      method: "GET",
      url: `/api/v1/ecommerce/get_product/${productId}?businessNumber=${businessNumber}`,
    }).then((data) => {
      if (data.status === 200) {
        const productDetails = data?.response?.data;
        setProduct(productDetails);
        getCategories();

        const filteredCategory = categories.find(item => item.categoryName === productDetails?.productCategory);

        setFormData({
          ...formData,
          productType: productDetails?.productType,
          productName: productDetails?.productName,
          productCategory: productDetails?.productCategory,
          isPackage: productDetails?.isPackage,
          noOfItemsInPackage: productDetails?.noOfItemsInPackage,
          productDescription: productDetails?.productDescription,
          featuredImage: productDetails?.featuredImage,
          thumbailImagePath: productDetails?.thumbailImagePath,
          additionalImages: productDetails?.additionalImages,
          variations: productDetails?.variations,
          productCategoryId: filteredCategory?._id,
          pricing: productDetails?.pricing,
          tags: productDetails?.tags,
          additionalServices: productDetails?.additionalServices
        })
        setAdditionalProductImages(productDetails?.additionalImages);
        setSelectedTags(productDetails?.tags);
        setSelectedAdditionalServices(productDetails?.additionalServices);
        setProductType(productDetails?.productType);
        setVariationId(productDetails?.pricing[0]?._id)


        setIsLoading(false);
      } else {
        setIsLoading(false);
        setErrorShow({ state: true, message: 'Failed to load product details' });
      }
    }).catch((error) => {
      setIsLoading(false);
      setErrorShow({ state: true, message: 'Error loading product details' });
    });
  };
  useEffect(() => {
    nextButtonState();
  }, [formData, displayBars, productId, pricingData]);

  const removeVariation = (variationName, variationValue) => {
    const updatedVariationData = variationData
      .map((item) => {
        if (item.variationName === variationName) {
          const newValue = item.variationValues.filter(
            (value) => value !== variationValue
          );
          return {
            ...item,
            variationValues: newValue.length > 0 ? newValue : null,
          };
        }
        return item;
      })
      .filter((item) => item && item.variationValues !== null); // Filter out items with null variationValues

    setVariationData(updatedVariationData);
    setFormData({ ...formData, variations: updatedVariationData });
    dispatch(setVariations(updatedVariationData));
    secureLocalStorage.setItem("variationData", JSON.stringify(updatedVariationData));
  };
  const removeAllVariationValues = (variationName) => {
    const updatedVariationData = variationData
      .map((item) => {
        if (item.variationName === variationName) {
          return null;
        }
        return item;
      })
      .filter((item) => item !== null);

    setVariationData(updatedVariationData);
    setFormData({ ...formData, variations: updatedVariationData });
    dispatch(setVariations(updatedVariationData));
    secureLocalStorage.setItem("variationData", JSON.stringify(updatedVariationData));
  };
  const handleFeaturedImage = async (event) => {
    setUploading('5');
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      try {
        const file = URL.createObjectURL(selectedFile);
        setProductFeaturedImage(file);
        const { imageUrl, thumbnailUrl } = await generateImageUrl(selectedFile);

        dispatch(setFeaturedImage(imageUrl));
        dispatch(setThumbnailImage(thumbnailUrl));
        setFormData({ ...formData, featuredImage: imageUrl, thumbailImagePath: thumbnailUrl });

        setUploading(null);
      } catch (error) {
        setUploading(null);
      }
    } else {
      setUploading(null);
    }
  };

  const handleAdditionalImages = async (event, index) => {
    setUploading(index);
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      try {
        const fileUrl = URL.createObjectURL(selectedFile);

        const { imageUrl, thumbnailUrl } = await generateImageUrl(selectedFile);

        const updatedImages = [...additionalProductImages];
        updatedImages[index] = { id: index, image: imageUrl };

        setAdditionalProductImages(updatedImages);
        setFormData(prevFormData => ({
          ...prevFormData,
          additionalImages: updatedImages,
        }));

        setUploading(null);
      } catch (error) {
        setUploading(null);
      }
    } else {
      setUploading(null);
    }
  };

  useEffect(() => {
    dispatch(setAdditionalImages(additionalProductImages));
  }, [additionalProductImages, dispatch]);

  const getCategories = () => {
    const businessNumber = secureLocalStorage.getItem("businessId");
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/get_categories?businessNumber=${businessNumber}&categoryName=${categorySearch}&limit=${limit}`
    }).then((data) => {
      const options = [];
      let rawCategories = data.response.data;
      const addCategoryWithLevel = (category, level = 0) => {
        options.push({
          label: category.categoryName,
          value: category.categoryName,
          level,
          id: category?._id,
          disabled: category.subCategories.length > 0
        });
        category.subCategories.forEach(subCategory => {
          addCategoryWithLevel(subCategory, level + 1);
        });
      };

      const filteredCategory = rawCategories.find(item => item.categoryName === product?.productCategory);
      if (filteredCategory) {
        setFormData({
          ...formData,
          productCategoryId: filteredCategory?._id,
        });
      }
      rawCategories.forEach(category => addCategoryWithLevel(category));
      setCategories(prevCategories => data?.response?.data?.length > 0 ? options : [...prevCategories, ...options]);
      setLimit(data?.response?.count);
    }).catch((error) => {
    });
  }
  useEffect(() => {
    fetchBusinessVariations();
    fetchBusinessTags();
    fetchAdditionalServices();
    fetchProductDetails();
  }, [])
  useEffect(() => {
    getCategories();
  }, [categorySearch]);
  


  return (
    <div>
      <SuccessAlert vertical="top" horizontal="right" onClose={() => setSuccessShow({ ...successShow, state: false })} open={successShow.state} message={successShow.message} />
      <ErrorAlert vertical="top" horizontal="right" onClose={() => setErrorShow({ ...errorShow, state: false })} open={errorShow.state} message={errorShow.message} />

      {/* Loading Overlay */}
      {isLoading && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9999
        }}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2
          }}>
            <CircularProgress size={60} sx={{ color: '#032541' }} />
            <Typography sx={{
              color: '#fff',
              fontSize: '16px',
              fontWeight: 600,
              fontFamily: 'Poppins'
            }}>
              Loading product details...
            </Typography>
          </Box>
        </Box>
      )}

      <div style={{ marginTop: "4%" }}>
      <Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
          <Box sx={{ flexDirection: "column" }}>
            <Box>
              <Typography variant="h4" sx={{ color: "#032541", fontSize: isMobile ? "22px" : "28px", fontStyle: "normal", fontWeight: "600", display: "flex", alignItems: "center", gap: 1}}>
                <ArrowBackIos sx={{ fontSize: isMobile ? "18px" : "20px" }} onClick={() => navigate(-1)} /> Edit Product
              </Typography>
            </Box>
            <Box>
            <Breadcrumbs style={{ fontFamily: 'Poppins', fontSize: '14px', marginLeft: '3px', marginBottom: '20px' }} separator={<FiberManualRecordIcon style={{ fontSize: "0.625rem", fontFamily: 'Poppins', color: "#e1e5e8" }} />} aria-label="breadcrumb">
                <Typography sx={{ color: "#707070", fontSize: "0.875rem" }}>Dashboard</Typography>
                <Typography sx={{ color: "#707070", fontSize: "0.875rem" }}>Inventory</Typography>
                <Typography sx={{ color: "#707070", fontSize: "0.875rem" }}>Products</Typography>
                <Typography sx={{ color: "#dc3545", fontSize: "0.875rem" }}>Edit Product</Typography>
            </Breadcrumbs>
              <Typography variant="h4" sx={{ color: "#707070", fontSize: isMobile ? "12px" : "14px", fontStyle: "normal", fontWeight: "normal", mt: isMobile ? 1 : 0}}>
                Update your product details.
              </Typography>
            </Box>
          </Box>
          <Box style={{ marginRight: isMobile ? "0" : "15px", width: isMobile ? "100%" : "auto" }}>
            <Button variant="contained" sx={{ backgroundColor: "#f5f6f7", color: "#6e7074", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", width: isMobile ? "100%" : "125px", height: "40px", fontWeight: "600", opacity: "0.99", "&:hover": { backgroundColor: "#f5f6f7", color: "#6e7074" } }} onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </Box>
        </Box>
        <Box sx={{ display: "flex" }}></Box>
        <Grid item width={isMobile ? "100%" : "70%"} style={{ margin: "15px 0px 0px 0px" }}>
          <Typography sx={{ margin: isMobile ? '20px 0 15px 0' : '20px 709px 15px 2px', fontFamily: 'Poppins', fontSize: isMobile ? '14px' : '16px', textAlign: 'left', color: '#000', fontWeight: 600 }}>
            What type of product are you adding?
          </Typography>
          <TextField style={{ width: isMobile ? "100%" : "50%" }} value={productType} id="outlined-select-meals" select label="Product Type" helperText="" name="paymentType" onChange={(event) => setProductType(event.target.value)} size={isSmallMobile ? "small" : "medium"}>
            {productTypeOptions?.map((prod, index) => (
              <div key={prod.id} value={prod.value} style={{ padding: "10px 10px 10.5px" }} onClick={() => handleproductTypeOptionsChange(prod.value)}>
                <div onClick={() => handleproductTypeOptionsChange(prod.value)}>
                  <Typography variant="body1" style={{ color: "#000", fontSize: isMobile ? "15px" : "17px", fontWeight: "600" }} onClick={() => handleproductTypeOptionsChange(prod.value)}>
                    {prod.label}
                  </Typography>
                </div>
                <div style={{ color: "#707070", paddingBottom: "10px", fontSize: isMobile ? "13px" : "14px" }} onClick={() => handleproductTypeOptionsChange(prod.value)}>
                  {prod.description}
                </div>
                <Divider />
              </div>
            ))}
          </TextField>
        </Grid>
        {productType && <Box>
          <Typography variant="h4" sx={{ color: "#000", fontSize: isMobile ? "16px" : "18px", fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>
            {productType === "simple_product" ? "Simple Product Details" : "Variable Product Details"}
          </Typography>
        </Box>
        }
        {productType && <Box sx={{ display: "flex", justifyContent: "center", maxWidth: displayBars === "productImage" ? (isMobile ? "100%" : "980px") : (isMobile ? "100%" : "800px"), marginTop: "20px", flexDirection: isMobile ? "column" : "row"}}>
          <Box style={{ width: isMobile ? "100%" : "30%", borderTop: "1px solid #e0e0e0", height: "100%", order: isMobile ? 1 : 0}}>
            <Box style={displayBars === "productDetails" ? activeClassBar : inactiveClassBar} onClick={() => handleChangeBars("productDetails")}>
              <Typography variant="h4" sx={displayBars === "productDetails" ? activeClassText : inactiveClassText}>
                Product Details
              </Typography>
            </Box>
            <Divider />
            <Box style={displayBars === "productImage" ? activeClassBar : inactiveClassBar} sx={{ paddingTop: isMobile ? "0" : "10px" }} onClick={() => handleChangeBars("productImage")}>
              <Typography variant="h4" sx={displayBars === "productImage" ? activeClassText : inactiveClassText}>
                Images
              </Typography>
            </Box>
            <Divider />
            <Box style={displayBars === "productVariations" ? activeClassBar : inactiveClassBar} sx={{ paddingTop: isMobile ? "0" : "10px", display: productType === 'simple_product' ? 'none' : '' }} onClick={() => handleChangeBars("productVariations")}>
              <Typography variant="h4" sx={displayBars === "productVariations" ? activeClassText : inactiveClassText}>
                Variations
              </Typography>
            </Box>
            <Divider />
            <Box style={displayBars === "productPricing" ? activeClassBar : inactiveClassBar} sx={{ paddingTop: isMobile ? "0" : "10px" }} onClick={() => handleChangeBars("productPricing")}>
              <Typography variant="h4" sx={displayBars === "productPricing" ? activeClassText : inactiveClassText}>
                Pricing & Stock
              </Typography>
            </Box>
            <Divider />
            <Box style={displayBars === "tags" ? activeClassBar : inactiveClassBar} sx={{ paddingTop: "10px" }} onClick={() => handleChangeBars("tags")}>
              <Typography variant="h4" sx={displayBars === "tags" ? activeClassText : inactiveClassText}>
                Tags
              </Typography>
            </Box>
            <Divider />
            {servicesEnabled === true && <Box style={displayBars === "additionalServices" ? activeClassBar : inactiveClassBar} sx={{ paddingTop: "10px" }} onClick={() => handleChangeBars("additionalServices")}>
              <Typography variant="h4" sx={displayBars === "additionalServices" ? activeClassText : inactiveClassText}>
                Additional Services
              </Typography>
            </Box>}
            <Divider />
          </Box>
          <Box style={{ width: isMobile ? "100%" : "70%", borderTop: "1px solid #e0e0e0", borderRight: "1px solid #e0e0e0", height: "100%", borderBottom: "1px solid #e0e0e0", borderLeft: "1px solid #e0e0e0", paddingBottom: "40px", order: isMobile ? 0 : 1}}>
            {displayBars === "productDetails" ? (
              <Box sx={{ padding: isMobile ? "16px" : "0px 20px" }}>
                <Typography variant="h4" sx={{ color: "#000", fontSize: isMobile ? "14px" : "16px", fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>
                  Product Details
                </Typography>
                <Box sx={{ marginTop: "25px" }}>
                  <TextField label="Product Name" value={formData?.productName} name="productName" onChange={handleFormData} style={{ width: "100%" }} size={isSmallMobile ? "small" : "medium"}/>
                </Box>
                <Box sx={{ marginTop: "25px" }}>
                  <Autocomplete
                    style={{ width: "100%" }}
                    id="outlined-select-meals"
                    options={categories}
                    getOptionDisabled={(option) => option.disabled}
                    getOptionLabel={(option) => option.label}
                    value={formData?.productCategory ? { label: formData.productCategory } : null}
                    onInputChange={(event, newInputValue) => {
                      setCategorySearch(newInputValue);
                    }}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setFormData(prevFormData => ({
                          ...prevFormData,
                          productCategory: newValue.label,
                          productCategoryId: newValue?.id
                        }));
                      } else {
                        setFormData(prevFormData => ({
                          ...prevFormData,
                          productCategory: '',
                          productCategoryId: ''
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Product Category"
                        helperText=""
                        size={isSmallMobile ? "small" : "medium"}
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        {...props}
                        sx={{ ml: option.level * 2 }}
                      >
                        {option.label}
                      </Box>
                    )}
                  />
                  <Box sx={{ marginTop: "15px" }}>
                    <TextField label="Product Description" value={formData?.productDescription} name="productDescription" onChange={handleFormData} style={{ width: "100%" }} multiline minRows={3} size={isSmallMobile ? "small" : "medium"}/>
                  </Box>
                  <Box sx={{ marginTop: "25px", display: 'flex' }}>
                    <Checkbox style={{ color: "#b4bcc4", margin: isMobile ? '10px 6px 10px 0px' : '10px 6px 37px 0px' }} checked={formData?.isPackage} value={formData?.isPackage} onChange={(e) => {setFormData({ ...formData, isPackage: !formData?.isPackage });}} size={isSmallMobile ? "small" : "medium"}/>
                    <Typography sx={{ margin: isMobile ? '10px 6px 10px 12px' : '20px 6px 37px 12px', fontSize: isMobile ? '14px' : '16px', color: '#707070', fontFamily: 'Poppins' }}>Is a Package</Typography>
                  </Box>
                  {formData?.isPackage && <Box >
                    <TextField type="number" label="No. of Items per Package" value={formData?.noOfItemsInPackage} name="noOfItemsInPackage" onChange={handleFormData} style={{ width: "100%" }} size={isSmallMobile ? "small" : "medium"}/>
                  </Box>}
                </Box>
              </Box>
            ) : displayBars === "productImage" ? (
              <Box sx={{ padding: isMobile ? "16px" : "0px 20px", minHeight: "250px" }}>
                <Box sx={{ display: "flex", marginTop: "20px", flexDirection: isMobile ? "column" : "row" }}>
                  <Typography sx={{ width: isMobile ? "100%" : "114px", height: "20px", margin: isMobile ? "0 0 10px 0" : "0 226px 10px 0", fontFamily: "Poppins", fontSize: isMobile ? "13px" : "14px", fontWeight: 600, color: "#000", textAlign: "left" }}>
                    Featured Image
                  </Typography>
                  <Typography sx={{ width: isMobile ? "100%" : "152px", height: "20px", margin: isMobile ? "0 0 10px 0" : "0 81px 10px 22px", fontFamily: "Poppins", fontSize: isMobile ? "13px" : "14px", fontWeight: 600, color: "#000", textAlign: "left" }}>
                    Upload Other Images
                  </Typography>
                </Box>
                <Grid container spacing={isMobile ? 2 : 0}>
                  <Grid item xs={12} md={6}>
                    <label htmlFor="featured-image">
                      <input style={{ display: "none" }} id="featured-image" name="featured-image" type="file" onChange={handleFeaturedImage} accept=".png, .jpeg, .jpg" />
                      <Box sx={{ width: "100%", height: isMobile ? "250px" : "320px", borderRadius: "12px", border: "solid 1px #e0e0e0", backgroundColor: "#fff" }}>
                        <Box sx={{ width: "calc(100% - 20px)", height: "calc(100% - 20px)", borderRadius: "5px", backgroundColor: "#f5f5f5", margin: "10px", textAlign: "center", alignContent: "center", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                          {featuredImage || product?.featuredImage ? <>
                            <img src={formData?.featuredImage} alt="" style={{ width: "100%", height: "100%", maxHeight: isMobile ? '180px' : '250px', maxWidth: isMobile ? '180px' : '250px', objectFit: "contain", alignItems: "center", textAlign: "center" }} />
                          </> :
                            <>
                              <img src={imagePlaceholder} alt="" style={{ width: "60.6px", height: "60.6px", objectFit: "contain", alignItems: "center", textAlign: "center" }} />
                              <Typography sx={{ width: isMobile ? "100%" : "196px", height: "17px", margin: isMobile ? "21.4px 0 9px 0" : "21.4px 0 9px 50px", fontFamily: "Poppins", fontSize: isMobile ? "12px" : "14px", color: "#000", fontWeight: 500 }}>
                                Click to upload or drag and drop
                              </Typography>
                              <Typography sx={{ width: isMobile ? "100%" : "196px", height: "17px", margin: isMobile ? "11.4px 0 2px 0" : "11.4px 0 2px 50px", fontFamily: "Poppins", fontSize: isMobile ? "10px" : "12px", color: "#707070", fontWeight: "normal" }}>
                                PNG, JPG or WebP
                              </Typography>
                              <Typography sx={{ width: isMobile ? "100%" : "196px", height: "17px", margin: isMobile ? "4px 0 9px 0" : "4px 0 9px 50px", fontFamily: "Poppins", fontSize: isMobile ? "10px" : "12px", color: "#707070", fontWeight: "normal" }}>
                                Recommended size (1000px x 1000px)
                              </Typography>
                            </>
                          }
                          {uploading === '5' &&
                            <Box sx={{ mt: 1 }}>
                              <LinearProgress sx={{ marginTop: '0%' }} /> <Typography sx={{ fontSize: isMobile ? "12px" : "14px" }}>Uploading File... </Typography>
                            </Box>
                          }
                        </Box>
                      </Box>
                    </label>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography sx={{ width: isMobile ? "100%" : "225px", height: "35px", margin: isMobile ? "10px 0 25px 0" : "10px 10px 25px 20px", fontFamily: "Poppins", fontSize: isMobile ? "12px" : "14px", fontWeight: "normal", color: "#707070", textAlign: "left" }}>
                      Recommended size (1000px x 1000px) PNG, JPG or JEPG
                    </Typography>
                    <Grid container spacing={isMobile ? 1 : 2}>
                      {additionalImagesItems.map((item, index) => (
                        <Grid key={index} item sx={{ display: "flex" }} xs={6} md={6}>
                          <label htmlFor={`other-images-${index}`}>
                            <input style={{ display: "none" }} id={`other-images-${index}`} name={`other-images-${index}`} type="file" onChange={(event) => handleAdditionalImages(event, index)} />
                            <Box sx={{ width: "100%", height: "auto", margin: isMobile ? "5px 0 10px 0" : "5px 28px 10px 20px", padding: isMobile ? "8px" : "11px", borderRadius: "8px", border: "solid 1px #e0e0e0", backgroundColor: "#fff" }}>
                              <Box sx={{ width: "100%", height: isMobile ? "70px" : "88px", padding: isMobile ? "5px" : "7.3px 20px 40px 20px", borderRadius: "5px", backgroundColor: "#f5f5f5", alignContent: "center", textAlign: "center", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                                {!additionalProductImages.length > 0 && <Add sx={{ width: "26.8px", height: "26.8px", color: "#E0E0E0" }} />}
                                <img src={additionalProductImages.length > 0 && additionalProductImages[index] ? additionalProductImages[index].image : imagePlaceholder} alt="" style={{ width: additionalProductImages.length > 0 && additionalProductImages[index] ? '100%' : '48.2px', height: additionalProductImages.length > 0 && additionalProductImages[index] ? '100%' : '48.2px', objectFit: "contain", margin: isMobile ? "5px 0 0 0" : "15px 15px 0px 0" }} />
                                {uploading === index &&
                                  <Box sx={{ mt: 0.5 }}>
                                    <LinearProgress sx={{ marginTop: '0%' }} /> <Typography sx={{ fontSize: isMobile ? "10px" : "12px" }}>Uploading... </Typography>
                                  </Box>
                                }
                              </Box>
                            </Box>
                          </label>
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            ) : displayBars === "productVariations" ? (
              <Box sx={{ padding: isMobile ? "16px" : "0px 20px", minHeight: "250px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="h4" sx={{ color: "#000", fontSize: isMobile ? "14px" : "16px", fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>
                    Product Variations
                  </Typography>
                  <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }} onClick={handleOPenVariantAdd}>
                    <Typography variant="h4" sx={{ color: "#032541", fontSize: "14px", fontStyle: "normal", fontWeight: "600" }}>
                      <AddCircleOutlineIcon />
                    </Typography>
                    <Typography variant="h4" sx={{ color: "#032541", fontSize: "14px", fontStyle: "normal", fontWeight: "600", marginTop: "5px" }}>
                      Add Variations
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ marginTop: "10px" }}>
                  {allBusinessVariations?.length > 0 && (
                    <Box sx={{ marginTop: "10px", display: "flex" }}>
                      <Box sx={{ width: "100%" }}>
                        {allBusinessVariations?.map((item, index) => {
                          return (
                            <Box key={index}>
                              <Box key={index} sx={{ display: "flex" }}>
                                <FormGroup>
                                  <FormControlLabel control={<Checkbox checked={checkedVariations[item?.variationName] ?? false} onChange={() => handleCheckboxChange(index)} size={isSmallMobile ? "small" : "medium"}/>} label={item?.variationName} />
                                </FormGroup>
                              </Box>
                              {checkedVariations[item?.variationName] && (
                                <Box sx={{ display: "flex", marginTop: "5px", flexWrap: 'wrap', gap: 1 }}>
                                  {item?.variationValues?.map((value, valueIndex) => {
                                   // Check if this value exists in formData.variations for this specific variation
                                   const isInFormDataVariations = formData.variations?.find((v) => v.variationName === item.variationName)?.variationValues?.some(val => val.trim().toUpperCase() === value.trim().toUpperCase());
                                   const isInExistingPricing = formData.pricing?.some((p) =>p?.variationKey?.split(",")?.map((f) => f.trim()).includes(value.trim()));
                                   const isCheckedInNew = newSelectedVariationValues?.find((v) => v.variationName === item.variationName)?.variationValues.includes(value.trim());
                                   const isChecked = isInFormDataVariations || isInExistingPricing || isCheckedInNew;
                                    return (
                                      <Box key={valueIndex} sx={{ minWidth: "auto", padding: "4px 8px", backgroundColor: "#efefef", borderRadius: "5px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                                        <FormControlLabel
                                          control={
                                            <Checkbox
                                                checked={isChecked}
                                                onChange={(e) => {
                                                  const { checked } = e.target;
                                                  if (isInExistingPricing) {
                                                    handleChildCheckboxToggle(item, value, checked, index);
                                                  } else {
                                                    handleNewChildCheckboxToggle(item, value, checked);
                                                  }
                                                }}
                                                size={isSmallMobile ? "small" : "medium"}
                                             />
                                          }
                                          label={value}
                                          sx={{ m: 0 }}
                                        />
                                      </Box>
                                    )
                                  })}
                                </Box>
                              )}
                            </Box>
                          )
                        })}
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
            ) : displayBars === "productPricing" ? (
              <Box sx={{ padding: isMobile ? "16px" : "0px 20px", minHeight: "250px" }}>
                <Typography variant="h4" sx={{ color: "#000", fontSize: isMobile ? "14px" : "16px", fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>
                  Pricing & Stock
                </Typography>
                <Typography variant="h6" sx={{ color: "#707070", fontSize: isMobile ? "12px" : "14px", fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>
                  {productType === "simple_product" ? "Set the pricing and stock of the product" : "Set the price and stock for each product variation."}
                </Typography>
                {productType === "simple_product" ? (
                  <>
                    <Box sx={{ marginTop: "25px", display: "flex", justifyContent: "space-between", flexDirection: isMobile ? "column" : "row", gap: isMobile ? 2 : 0}}>
                      <TextField label="Initial Stock" value={pricingObj.pricing.initialStock} name="initialStock" onChange={(e) => setpricingObj({ ...pricingObj, pricing: { ...pricingObj.pricing, initialStock: e.target.value } })} style={{ width: "100%", marginRight: isMobile ? "0" : "10px" }} size={isSmallMobile ? "small" : "medium"}/>
                      <TextField label="Running Low Level" value={pricingObj.pricing.runningLowLevel} name="runningLowLevel" onChange={(e) => setpricingObj({ ...pricingObj, pricing: { ...pricingObj.pricing, runningLowLevel: e.target.value } })} style={{ width: "100%" }} size={isSmallMobile ? "small" : "medium"}/>
                    </Box>
                    <Box sx={{ marginTop: "25px", display: "flex", justifyContent: "space-between",flexDirection: isMobile ? "column" : "row",gap: isMobile ? 2 : 0}}>
                      <TextField label="Normal Price" value={pricingObj.pricing.normalPrice} name="normalPrice" onChange={(e) => setpricingObj({ ...pricingObj, pricing: { ...pricingObj.pricing, normalPrice: e.target.value } })} style={{ width: "100%", marginRight: isMobile ? "0" : "10px" }} size={isSmallMobile ? "small" : "medium"}/>
                      <TextField label="Discounted  Price" value={pricingObj.pricing.discountedPrice} name="discountedPrice" onChange={(e) => setpricingObj({ ...pricingObj, pricing: { ...pricingObj.pricing, discountedPrice: e.target.value } })} style={{ width: "100%" }} size={isSmallMobile ? "small" : "medium"}/>
                    </Box >
                    <Box sx={{ marginTop: "20px" }}>
                      <TextField label="Buy Price" value={pricingObj.pricing.buyingPrice} name="buyingPrice" onChange={(e) => setpricingObj({ ...pricingObj, pricing: { ...pricingObj.pricing, buyingPrice: e.target.value } })} style={{ width: '100%', marginRight: isMobile ? "0" : "10px" }} size={isSmallMobile ? "small" : "medium"}/>
                    </Box>
                  </>
                ) : productType === "variable_product" ? (
                  formData.variations && formData.variations.length === 0 ? (
                    <Box sx={{ marginTop: "25px" }}>
                      <Typography variant="h6" sx={{ color: "#707070", fontSize: isMobile ? "12px" : "14px", fontStyle: "normal", fontWeight: "600" }}>
                        Please add variations to set pricing and stock
                      </Typography>
                    </Box>
                  ) : (
                    <EditPricingComponent
                      variationData={mergeVariations(formData.variations || [], newSelectedVariationValues || [])}
                      checkedVariations={checkedVariations}
                      originalPricing={[...(formData.pricing || []), ...(formData.newPricing || [])]}
                      originalVariations={formData.variations}
                    />
                  )
                ) : null}
              </Box>
            ) : displayBars === "tags" ? (
              <Box sx={{ padding: isMobile ? "16px" : "16px 14.5px 7px 17px", minHeight: "250px", margin: isMobile ? "19px 0 25px 0" : '19px 25px 25px 25px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: isMobile ? "column" : "row", gap: isMobile ? 2 : 0}}>
                  <Box sx={{ flexDirection: 'column' }}>
                    <Typography sx={{ margin: isMobile ? '0 0 10px 0' : '0 200px 10px 0', fontFamily: 'Poppins', fontSize: isMobile ? '14px' : '16px', fontWeight: 600, color: '#000', textAlign: 'left' }}> Tags</Typography>
                    <Typography sx={{ margin: isMobile ? '10px 0 10px 0' : '10px 82px 10px 0', fontFamily: 'Poppins', fontSize: isMobile ? '12px' : '14px', textAlign: 'left', color: '#707070', textWrap: isMobile ? 'wrap' : 'nowrap' }}> Select tags to this product</Typography>
                  </Box>
                  <Box sx={{ display: 'flex' }} onClick={handleOPenTagsAdd}>
                    <AddCircleOutline sx={{ width: '18.6px', height: '18.6px', color: '#032541' }} />
                    <Typography sx={{ margin: '0 0 0 6px', fontFamily: 'Poppins', fontSize: isMobile ? '12px' : '14px', fontWeight: 600, color: '#032541', textWrap: isMobile ? 'wrap' : 'nowrap' }}> Add Tags</Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', mt: 2 }}>
                  {
                    tags?.map((tag) => (
                      <FormControlLabel key={tag?._id} control={ <Checkbox checked={selectedTags?.some(selectedTag => selectedTag?.tagId === tag?._id)} value={tag?._id} onChange={handleChange} inputProps={{ 'aria-label': 'controlled', backgroundColor: '#032541', textWrap: 'nowrap' }} size={isSmallMobile ? "small" : "medium"}/>} name={tag?.tagName} label={tag?.tagName} />
                    )
                    )}
                </Box>
              </Box>
            ) : displayBars === "additionalServices" ? (
              <Box sx={{ padding: isMobile ? "16px" : "16px 14.5px 7px 17px", minHeight: "250px", margin: isMobile ? "19px 0 25px 0" : '19px 25px 25px 25px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: isMobile ? "column" : "row", gap: isMobile ? 2 : 0}}>
                  <Box sx={{ flexDirection: 'column' }}>
                    <Typography sx={{ margin: isMobile ? '0 0 10px 0' : '0 200px 10px 0', fontFamily: 'Poppins', fontSize: isMobile ? '14px' : '16px', fontWeight: 600, color: '#000', textAlign: 'left', textWrap: isMobile ? 'wrap' : 'nowrap' }}> Additional Services</Typography>
                    <Typography sx={{ margin: isMobile ? '10px 0 10px 0' : '10px 82px 10px 0', fontFamily: 'Poppins', fontSize: isMobile ? '12px' : '14px', textAlign: 'left', color: '#707070', textWrap: isMobile ? 'wrap' : 'nowrap' }}>
                      Select additional services to this product
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex' }} onClick={handleOPenServicesAdd}>
                    <AddCircleOutline sx={{ width: '18.6px', height: '18.6px', color: '#032541' }} />
                    <Typography sx={{ margin: '0 0 0 6px', fontFamily: 'Poppins', fontSize: isMobile ? '12px' : '14px', fontWeight: 600, color: '#032541', textWrap: isMobile ? 'wrap' : 'nowrap' }}>
                      Add Services
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', mt: 2 }}>
                  {
                    additionalServices?.map((service) => (
                      <Box sx={{ width: '100%' }}>
                        <Accordion sx={{ boxShadow: 'none', width: '100%' }}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ width: '100%' }} />} aria-controls="panel1-content" id="panel1-header">
                            <FormControlLabel key={service._id} control={ <Checkbox checked={selectedAdditionalServices?.some(selectedService => selectedService.serviceId === service._id)} value={service._id} onChange={handleChangeAdditionalServices} inputProps={{ 'aria-label': 'controlled', backgroundColor: '#032541', flexDirection: 'column' }} size={isSmallMobile ? "small" : "medium"}/> } name={service.serviceName} label={service.serviceName} />
                          </AccordionSummary>
                          {service?.items?.map((serviceItem) => (
                            <AccordionDetails sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                              <Typography sx={{ fontSize: isMobile ? '12px' : '14px' }}>{serviceItem?.itemName}</Typography>
                              <Typography sx={{ fontSize: isMobile ? '12px' : '14px' }}>+ {serviceItem?.itemPrice}</Typography>
                            </AccordionDetails>
                          ))}
                        </Accordion>
                      </Box>
                    )
                    )}
                </Box>
              </Box>
            ) : (
              <Box sx={{ padding: isMobile ? "16px" : "0px 20px", minHeight: "250px" }}>
                Product Details
              </Box>
            )}
          </Box>
        </Box>
        }
        {productType && <Box style={{ width: isMobile ? "100%" : "800px", height: "390px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          {displayBars !== "productDetails" && (
            <Button variant="contained" sx={{ backgroundColor: "#f5f6f7", color: "#6e7074", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", width: "125px", height: "40px", marginTop: "20px", fontWeight: "600", "&:hover": { backgroundColor: "#f5f6f7", color: "#6e7074" } }} onClick={handlePrevious}>
              Previous
            </Button>
          )}
          <Button disabled={buttonState} variant="contained" sx={{ backgroundColor: !buttonState ? "#032541" : "#707070", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", width: isMobile ? "100%" : "125px", height: "40px", marginTop: "20px", "&:hover": { backgroundColor: !buttonState ? "#032541" : "#707070" } }} onClick={handleNext}>
            {displayBars === "additionalServices" || (displayBars === "tags" && !servicesEnabled) ? "Submit" : "Next"}
          </Button>
        </Box>
        }
      </Box>
      
      </div>
      {/* Modals */}
      <Modal open={openVariantAdd} onClose={handleCloseVariantAdd} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" border="none">
        <Box sx={AddProductsmodal}>
          <Box sx={{ padding: "10px" }}>
            <Box>
              <Typography variant="h4" sx={{ color: "#032541", fontSize: isMobile ? "18px" : "20px", fontStyle: "normal", fontWeight: "600" }}>
                Add Variations
              </Typography>
            </Box>
            <Box sx={{ marginTop: "20px" }}>
              <CustomInputLabel label={"Variation Name"} name={"variationName"} required={true} />
              <Typography variant="h5" sx={{ color: "#707070", fontSize: isMobile ? "11px" : "12px", fontStyle: "normal", fontWeight: "600" }}>
                Name is the attribute of the variation e.g Size
              </Typography>
              <TextField helperText={variationNameHelperText} error={variationNameError} label="Variation Name" value={variationName} name="variationName" onChange={handleChangeVariationName} style={{ width: "100%" }} size={isSmallMobile ? "small" : "medium"}/>
            </Box>
            <Box sx={{ marginTop: "20px" }}>
              <CustomInputLabel label={"variationValues"} name={"variationValues"} required={true} />
              <Typography variant="h5" sx={{ color: "#707070", fontSize: isMobile ? "11px" : "12px", fontStyle: "normal", fontWeight: "600" }}>
                Values are different attributes in the variation e.g Medium
              </Typography>
              <TextField label="variation Values" value={variationValues} name="variationValues" onChange={(e) => setVariationValues(e.target.value)} style={{ width: "100%" }} size={isSmallMobile ? "small" : "medium"}/>
              <Box sx={{ marginTop: "5px", display: "flex", justifyContent: "flex-end" }}>
                <Typography variant="h5" sx={{ color: "#707070", fontSize: isMobile ? "11px" : "12px", fontStyle: "normal", fontWeight: "600" }}>
                  Separate multiple values with a comma "," e.g Medium, Large
                </Typography>
              </Box>
            </Box>
            <Box sx={{ marginTop: "20px", display: "flex", justifyContent: "flex-end", flexDirection: isMobile ? "column" : "row", gap: isMobile ? 1 : 0}}>
              <Button variant="contained" sx={{ backgroundColor: "#f5f6f7", color: "#6e7074", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", width: isMobile ? "100%" : "125px", height: "40px", marginRight: isMobile ? "0" : "10px", "&:hover": { backgroundColor: "#f5f6f7" } }} onClick={handleCloseVariantAdd}>
                Cancel
              </Button>
              <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", width: isMobile ? "100%" : "125px", height: "40px", "&:hover": { backgroundColor: "#032541" } }} onClick={handleVariations}>
                Save
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={openTagsAdd} onClose={handleCloseTagsAdd} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" border="none">
        <Box sx={AddProductsmodal}>
          <Box sx={{ padding: "10px" }}>
            <Box>
              <Typography variant="h4" sx={{ color: "#032541", fontSize: "20px", fontStyle: "normal", fontWeight: "600" }}>
                Add Tags
              </Typography>
            </Box>
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <CustomInputLabel label="Tag  Name" placeholder="Enter Tag Name " />
              <TextField label="Tag Name" value={tagDataData?.tagName} name="tagName" onChange={handleTagsFormData} InputProps={{ sx: { width: "490px", height: '50px', fontSize: "0.875rem", "& fieldset": { borderColor: "#bec5d1", }, }, }} />
            </Box>
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <CustomInputLabel label="Tag Description" placeholder="Enter Tag  Description*" />
              <TextField name={"tagDescription"} value={tagDataData.tagDescription} onChange={handleTagsFormData} placeholder={"Description"} variant="outlined" margin="dense" sx={{ marginBottom: 2 }} multiline minRows={2} InputProps={{ sx: { width: "490px", height: '70px', fontSize: "0.875rem", "& fieldset": { borderColor: "#bec5d1", }, }, }} />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignContent: "end", mr: '80px' }}>
              <Button variant="contained" sx={{ backgroundColor: "#fff", color: "#dc3545", textTransform: "none", borderRadius: "5px", marginRight: "10px", border: "1px solid #dc3545", padding: "10.4px 30px 9.6px 30px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#fff", color: "#dc3545" } }} onClick={handleCloseTagsAdd}>
                Cancel
              </Button>
              <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" } }} onClick={handleTagAddSubmit}>
                Add Tag
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={openServicesAdd} onClose={handleCloseServicesAdd} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" border="none">
        <Box sx={AddServicesmodal}>
          <Box sx={{ padding: "10px" }}>
            <Box>
              <Typography variant="h4" sx={{ color: "#032541", fontSize: "20px", fontStyle: "normal", fontWeight: "600" }}>
                Add Additional Services
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left' }}>
              <Box sx={{ width: "50%" }}>
                <CustomInputLabel label="ServiceName Name" placeholder="Enter ServiceName Name" />
                <TextField label="Service Name" value={serviceData?.serviceName} name="serviceName" onChange={handleServicesFormData} style={{ width: "100%" }} placeholder="Enter Service Name" />
              </Box>
              <Box sx={{ width: "50%", marginLeft: "10px", marginTop: "-6px" }}>
                <CustomInputLabel label="Select Type" placeholder="Enter Select Type" />
                <CustomSelect value={serviceData?.selectionType} name="selectionType" options={selectOptions} onChange={handleServicesFormData} placeholder={"Select Type"} sm={"sm"} />
              </Box>
            </Box>
            <Typography variant="h4" sx={{ color: "#032541", fontSize: "20px", fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>Service Items</Typography>
            {serviceBoxes.map((box, index) => (
              <Box key={index}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left', marginBottom: '10px' }}>
                  <Box sx={{ width: "50%" }}>
                    <CustomInputLabel label="Service Name" placeholder="Enter Service Name" />
                    <TextField label="Service" value={box.serviceName} name={`serviceName-${index}`} onChange={(e) => {
                      const updatedBoxes = [...serviceBoxes];
                      updatedBoxes[index].serviceName = e.target.value;
                      setServiceBoxes(updatedBoxes);
                    }} style={{ width: "100%" }} placeholder="Service Name" />
                  </Box>
                  <Box sx={{ width: "50%", marginLeft: "10px", marginTop: "" }}>
                    <CustomInputLabel label="Cost" placeholder="Enter Cost" />
                    <TextField type="number" label="Service cost" value={box.cost} name={`cost-${index}`} onChange={(e) => {
                      const updatedBoxes = [...serviceBoxes];
                      updatedBoxes[index].cost = e.target.value;
                      setServiceBoxes(updatedBoxes);
                    }} style={{ width: "100%" }} />
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: "end", marginTop: "20px", marginLeft: "20px" }}>
                    <Typography variant="h4" sx={{ color: "#dc3545", fontSize: "30px", fontStyle: "normal", fontWeight: "600", marginTop: "20px", cursor: 'pointer' }} onClick={() => handleDeleteBox(index)}>
                      <DeleteIcon sx={{ fontSize: "30px" }} />
                    </Typography>
                  </Box>
                </Box>
                <Box style={{ display: "flex", }}>
                  <Checkbox style={{ color: "#b4bcc4", margin: '10px 6px 37px 0px', }} checked={box?.customizable} value={box?.customizable} onChange={(e) => {
                    const updatedBoxes = [...serviceBoxes];
                    updatedBoxes[index].customizable = !box?.customizable;
                    setServiceBoxes(updatedBoxes);
                  }} />
                  <Typography sx={{ margin: '20px 6px 37px 12px', fontSize: '16px', color: '#707070', fontFamily: 'Poppins' }}>Customizable</Typography>
                  <HelpOutline sx={{ color: "#b4bcc4", margin: '20px 6px 37px 12px', }} />
                </Box>
              </Box>
            ))}

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: "end" }}>

              <Typography variant="h4" sx={{ color: "#032541", fontSize: "14px", fontStyle: "normal", fontWeight: "600", marginTop: "20px", cursor: 'pointer' }} onClick={handleAddBox}>
                <AddCircleOutlineIcon sx={{ fontSize: "14px" }} />   Add Another
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: "end" }}>

              <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", marginTop: "20px", display: "flex", justifyContent: "flex-end" }} onClick={handleServiceSubmit}>
                Add  Service
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default EditProduct;
